import builder from '../builder';
import CloudDownload from '../../streamline-icons/light/cloud-download.svg';

export default builder('IconCloudDownloadLight', CloudDownload);
